import base from "/opt/buildhome/repo/images/animate-spin.svg?svg";
import { getResizer } from "svg-merge-attributes";
export default getResizer(base, "");